import { render } from "./Purchases.vue?vue&type=template&id=0a43c4ea&scoped=true"
import script from "./Purchases.vue?vue&type=script&lang=js"
export * from "./Purchases.vue?vue&type=script&lang=js"

import "./Purchases.vue?vue&type=style&index=0&id=0a43c4ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a43c4ea"]])

export default __exports__